import {
  getStaticPathsGenerator,
  getStaticPropsGenerator,
} from '@cinch-nx/landing-feature-articles-sub-hub'

const path = 'guides/electric-cars'
const resultsPerPage = 10

export const getStaticPaths = getStaticPathsGenerator()
export const getStaticProps = getStaticPropsGenerator({
  subHubPath: path,
  resultsPerPage: resultsPerPage,
  breadCrumbs: [
    { text: 'Home', url: '/' },
    { text: 'Guides', url: '/guides' },
    { text: 'Electric cars', url: `/${path}` },
  ],
  generatePageBreadcrumb: true,
})

export { ArticleSubHubFeature as default } from '@cinch-nx/landing-feature-articles-sub-hub'
